import React from "react";
import {NavLink} from "react-router-dom";

const Footer = () => {
  return (
    <>
      <hr />
      {/*<div className='text-center d-inline'>*/}
      {/*  <NavLink to="/client_func" className="nav-link d-inline-block">Functii Client</NavLink>*/}
      {/*  &nbsp;&nbsp;|&nbsp;&nbsp;*/}
      {/*  <NavLink to="/provider_func" className="nav-link d-inline-block">Functii Nutritionist</NavLink>*/}
      {/*</div>*/}
      <div className='footer text-center d-inline mb-3'>
        <NavLink to="/contact" className=" close-nav" aria-current="page">Contact</NavLink>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        <NavLink to="/privacy_policy" className=" close-nav" aria-current="page">
          Politica de Confidențialitate
        </NavLink>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        <NavLink to="/terms" className=" close-nav" aria-current="page">Termeni și condiții</NavLink>
      </div>
    </>
  )
}

export default Footer;
